<template>
  <div class="teacher-daily-row" style="height: 100%">
    <div class="teacher-daily-each-day-box">
      <div class="teacher-daily-svg-date">
        <div class="teacher-daily-light-green-font" style="margin: auto 0;">{{today.getDate()}}/{{today.getMonth() + 1}}/{{today.getFullYear()}}</div>
        <div class="teacher-daily-light-green-font" style="margin: auto 0;">{{weekNames[today.getDay()]}}</div>
      </div>
      <div class="teacher-daily-each-day-mission">
        <div v-for="(course, indexCourse) in courseMissionList" v-bind:key="indexCourse">
          <div class="teacher-daily-class">班級：{{course.courseTitle}}</div>
          <div v-for="(mission, indexMission) in course.missions" v-bind:key="indexMission" class="teacher-daily-box-content">
            <div class="teacher-daily-unfinish mission-name"><router-link :to="{
              name: 'ClassActivity',
              query: mission.query
              }"> - {{ mission.name }}</router-link></div>
            <!-- <div class="teacher-daily-due">到期！</div> -->
            <div class="teacher-daily-expected-time teacher-daily-green-font">（{{!isMobile ? '已完成人數：' : ''}}{{mission.completedStudent}}/{{mission.totalStudent}}人）</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .teacher-daily-light-green-font{
    color: #99CB32;
    font-size: 1rem;
  }
  .teacher-daily-row{
    padding:1rem;
  }
  .teacher-daily-due{
    background: #99CB32;
    color:#FFF;
    padding: 0rem 0.8rem;
    border-radius: 0.5rem;
    margin: 0 0 0 0.5rem;
  }
  .teacher-daily-green-font{
    color: #387E1E;
  }
  .teacher-daily-finish{
    color: #878A8B;
  }
  .teacher-daily-unfinish{
    color: #387E1E;
  }
  .teacher-daily-expected-time{
    position:absolute;
    right:0;
  }
  .teacher-daily-class{
    margin-top: 1rem;
    color: darkgreen;
    font-weight: bold;
  }
  .teacher-daily-each-day-box{
    position:relative;
    margin: 1rem;
    border: 1px solid #99CB32;
    border-radius: 3rem;
    min-height: 25rem;
  }
  .teacher-daily-box-content{
    display:flex;
    padding: 0.1rem 0;
    margin: 0 2.5rem;
  }
  .teacher-daily-svg-date{
    font-size: 2.5rem;
    margin: 0.8rem 1.5rem;
    display:flex;
    justify-content: space-between;
  }
  .teacher-daily-each-day-mission{
    margin: 0.8rem 2.5rem;
    font-size: 1.2rem;
  }
  .teacher-daily-each-row{
    height: 1rem;
  }
  @media screen and (max-width: 790px) {
    .teacher-daily-svg-date{
      font-size: 1rem;
    }
    .teacher-daily-each-day-mission{
      margin: 0.8rem 1rem;
    }
    .mission-name{
      width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
</style>
<script>
var moment = require('moment')
export default {
  props: {
    year: Number,
    month: Number,
    date: Number
  },
  data () {
    return {
      weekNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      today: (this.year && this.month && this.date) ? new Date(this.year, this.month, this.date) : new Date(),
      missions: []
    }
  },
  computed: {
    courseMissionList: function () {
      console.log(this.missions)
      let missions = this.missions.filter(mission => {
        return moment(this.today).format('YYYY-MM-DD') === moment(mission.endDatetime).format('YYYY-MM-DD')
        // return this.today === new Date(mission.endDatetime)
        // return new Date(mission.startDatetime) <= this.today && this.today <= new Date(mission.endDatetime)
      })
      missions = missions.reduce((acc, cur) => {
        let course = 0
        if (cur.query.course !== undefined) {
          course = cur.query.course
        }
        if (acc[course] === undefined) {
          acc[cur.query.course] = {
            courseId: course,
            courseTitle: cur.course_title !== undefined ? cur.course_title : '',
            missions: []
          }
        }
        acc[course].missions.push(cur)
        return acc
      }, {})
      console.log(Object.values(missions))
      return Object.values(missions)
    },
    isMobile: function () {
      return window.screen.width < 790
    }
  },
  async mounted () {
    console.log('here is Daily')
    this.$emit('loading')
    let res = await this.$store.dispatch('request', {
      route: `activities?start=${this.today.getFullYear()}-${this.today.getMonth() + 1}-${this.today.getDate()}&end=${this.today.getFullYear()}-${this.today.getMonth() + 1}-${this.today.getDate()}&type=weeks`
    })
    this.missions = res.activities
    this.$emit('loaded')
  }
}
</script>
